
import * as Actions from './actions.js'

const initialState = {
  loading: true,
  error: false,
  items: []
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Actions.INSURANCE:
      return {
        ...initialState,
        loading: true
      }
    case Actions.INSURANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        items: action.result
      }
    case Actions.INSURANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        items: []
      }
    default:
      return state
  }
}
